import type { ScanSeverity } from '@/lib/apiTypes'

// ── Version detail - tabbed ───────────────────────────────────────────────────
export const SEVERITIES: ScanSeverity[] = ['critical', 'high', 'medium', 'low', 'info']

